export const FILTER_BY = [
	{ label: 'AP_L1Category', value: 'AP_L1Category' },
	{ label: 'AP_L2Category', value: 'AP_L2Category' },
	{ label: 'AP_L3Category', value: 'AP_L3Category' },
	{ label: 'AP_L4Category', value: 'AP_L4Category' },
	{ label: 'PURCHASING_LOCATION_ID', value: 'PURCHASING_LOCATION_ID' },
	{ label: 'PURCHASING_LEGAL_ENTITY', value: 'PURCHASING_LEGAL_ENTITY' },
	{ label: 'PO_COST_CENTER', value: 'PO_COST_CENTER' },
	{ label: 'SITES', value: 'SITES' },
	{ label: 'CUSTOM_FILTER1', value: 'CUSTOM_FILTER1' },
	{ label: 'VENDOR_NAME', value: 'VENDOR_NAME' },
];
export const YEAR = [
	{ label: 2020, value: 2020 },
	{ label: 2021, value: 2021 },
	{ label: 2022, value: 2022 },
	{ label: 2023, value: 2023 },
];

export const GRAPHQL_PAYLOAD_DATA_UPDATE_HARMONIZED = {
	columnDefs: [
		{
			headerName: 'HARMONIZED VENDOR NAME',
			field: 'hARMONIZED_VENDOR_NAME',
			colId: 'hARMONIZED_VENDOR_NAME',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			rowGroup: true,
			hide: true,
			enableRowGroup: true,
		},
		{
			headerName: 'VENDOR NAME',
			field: 'vENDOR_NAME',
			colId: 'vENDOR_NAME',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			rowGroup: true,
			enableRowGroup: true,
			hide: true,
			minWidth: 180,
		},
		{
			headerName: 'SITE',
			field: 'site',
			colId: 'site',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			rowGroup: true,
			enableRowGroup: true,
			hide: true,
			cellStyle: { textAlign: 'center' },
			// hide: true,
			// rowGroup: true,
			// hide: true,
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'PURCHASING COUNTRY',
			field: 'pURCHASING_COUNTRY',
			colId: 'pURCHASING_COUNTRY',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			rowGroup: true,
			enableRowGroup: true,
			minWidth: 120,
			hide: true,
			cellStyle: { textAlign: 'center' },
			// hide: true,
			// rowGroup: true,
			// hide: true,
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Has Multiple Terms?',
			field: 'is_DPO_Multiple',
			colId: 'is_DPO_Multiple',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: ['YES', 'NO'],
			},
			minWidth: 130,
			cellStyle: { textAlign: 'center' },
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Total Amount Paid',
			field: 'total_amount_paid',
			colId: 'total_amount_paid',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			minWidth: 130,
			// headerClass: 'header-ag-blue',
			cellStyle: { textAlign: 'right' },
		},
		{
			headerName: 'Average Contract Term',
			field: 'average_DPO',
			colId: 'average_DPO',
			filter: 'agSetColumnFilter',
			cellStyle: { textAlign: 'center' },
			cellRenderer: params => {
				return Math.trunc(params.value);
			},
			filterParams: {
				values: [],
			},
			minWidth: 138,
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Realized Terms',
			field: 'realized_terms',
			colId: 'realized_terms',
			filter: 'agSetColumnFilter',
			cellStyle: { textAlign: 'center' },
			filterParams: {
				values: [],
			},
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Select',
			field: 'select',
			colId: 'select',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			editable: true,
			cellEditor: 'agSelectCellEditor',
			cellEditorParams: {
				values: ['YES', 'NO'],
			},
			headerClass: 'header-ag-blue',
			cellStyle: { textAlign: 'center' },
		},
		{
			headerName: 'Harmonization Opportunity Term',
			field: 'harmonization_Opportunity_Term',
			colId: 'harmonization_Opportunity_Term',
			filter: 'agSetColumnFilter',
			cellStyle: { textAlign: 'center' },
			filterParams: {
				values: [],
			},
			minWidth: 157,
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Extend Term',
			field: 'extend_Term',
			colId: 'extend_Term',
			filter: 'agSetColumnFilter',
			cellStyle: { textAlign: 'center' },
			filterParams: {
				values: [],
			},
			editable: true,
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Pcard Term',
			field: 'pcard_Term',
			colId: 'pcard_Term',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			cellStyle: { textAlign: 'center' },
			editable: true,
			hide: true,
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Harmonization Opportunity Term Reduction',
			field: 'harmonization_Opportunity_Term_Reduction',
			colId: 'harmonization_Opportunity_Term_Reduction',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			cellStyle: { textAlign: 'right' },
			// headerClass: 'header-ag-blue',
			minWidth: 225,
		},
		{
			headerName: 'Working Capital Reduction',
			field: 'working_capital_reduction',
			colId: 'working_capital_reduction',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			minWidth: 147,
			cellStyle: { textAlign: 'right' },
			// headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Pcard Reduction ',
			field: 'working_capital_reduction_pcard',
			colId: 'working_capital_reduction_pcard',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			hide: true,
			cellStyle: { textAlign: 'right' },
			// headerClass: 'header-ag-blue',
		},
		// Add other columns here as necessary
	],
	cteExist: true,
	cteModel: [
		{
			cteName: 'Vendor_Spend_Summary',
			filterModel: [],
			sorting: [],
			cteTable: '[sxr].[working_capital] a',
			rowGroups: [
				{
					id: '1',
					displayName: 'hARMONIZED_VENDOR_NAME',
					field: 'hARMONIZED_VENDOR_NAME',
					selector: 'a',
				},
			],
			caseModel: [],
			valueCols: [
				{
					id: '1',
					aggFunc: 'sum',
					displayName: 'po_base_spend',
					field: 'po_base_spend',
					selector: 'a',
					alias: 'total_amount_paid',
				},
				{
					id: '2',
					aggFunc: 'sum',
					displayName: 'po_base_spend * Realized_Payment_Term',
					field: 'po_base_spend * Realized_Payment_Term',
					selector: 'a',
					alias: 'numerator',
				},
				{
					id: '3',
					aggFunc: 'sum',
					displayName: 'po_base_spend * DPO',
					field: 'po_base_spend * DPO',
					selector: 'a',
					alias: 'numerator_1',
				},
			],
			joinModel: [],
			havingModel: [],
			groupCols: [
				{
					id: '1',
					displayName: 'hARMONIZED_VENDOR_NAME',
					field: 'hARMONIZED_VENDOR_NAME',
					selector: 'a',
				},
			],
			groupKeys: [],
		},
		{
			cteName: 'Vendor_Spend_Ratio',
			filterModel: [],
			sorting: [],
			cteTable: 'Vendor_Spend_Summary b',
			rowGroups: [
				{
					id: '1',
					displayName: 'hARMONIZED_VENDOR_NAME',
					field: 'hARMONIZED_VENDOR_NAME',
					selector: 'b',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'b',
				},
			],
			caseModel: [
				{
					whenCondition: 'total_amount_paid != 0',
					thenCondition: 'b.numerator / b.total_amount_paid',
					elseCondition: 'null',
					caseName: 'realized_terms',
				},
				{
					whenCondition: 'total_amount_paid != 0',
					thenCondition: 'b.numerator_1 / b.total_amount_paid',
					elseCondition: 'null',
					caseName: 'average_DPO',
				},
			],
			valueCols: [],
			joinModel: [],
			havingModel: [],
			groupCols: [],
			groupKeys: [],
		},
		{
			cteName: 'Vendor_DPO_Analysis',
			filterModel: [],
			sorting: [],
			cteTable: 'sxr.working_capital d',
			rowGroups: [
				{
					id: '1',
					displayName: 'hARMONIZED_VENDOR_NAME',
					field: 'hARMONIZED_VENDOR_NAME',
					selector: 'e',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'e',
				},
				{
					id: '3',
					displayName: 'realized_terms',
					field: 'realized_terms',
					selector: 'e',
				},
				{ id: '4', displayName: '[select]', field: '[select]', selector: 'd' },
				{
					id: '5',
					displayName: 'pcard_Term',
					field: 'pcard_Term',
					selector: 'd',
				},
				{
					id: '6',
					displayName: 'extend_Term',
					field: 'extend_Term',
					selector: 'd',
				},
				{
					id: '7',
					displayName: 'average_DPO',
					field: 'average_DPO',
					selector: 'e',
				},
				{
					id: '8',
					displayName: 'is_DPO_Multiple',
					field: 'is_DPO_Multiple',
					selector: 'd',
				},
				{
					id: '9',
					displayName: 'harmonization_Opportunity_Term',
					field: 'harmonization_Opportunity_Term',
					selector: 'd',
				},
			],
			caseModel: [],
			valueCols: [],
			joinModel: [
				{
					tableName: 'Vendor_Spend_Ratio AS e',
					condition: 'd.hARMONIZED_VENDOR_NAME = e.hARMONIZED_VENDOR_NAME',
					joinType: 'RIGHT JOIN',
				},
			],
			havingModel: [],
			groupCols: [
				{
					id: '1',
					displayName: 'hARMONIZED_VENDOR_NAME',
					field: 'hARMONIZED_VENDOR_NAME',
					selector: 'e',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'e',
				},
				{
					id: '3',
					displayName: 'realized_terms',
					field: 'realized_terms',
					selector: 'e',
				},
				{
					id: '4',
					displayName: 'extend_Term',
					field: 'extend_Term',
					selector: 'd',
				},
				{
					id: '5',
					displayName: 'pcard_Term',
					field: 'pcard_Term',
					selector: 'd',
				},
				{ id: '6', displayName: '[select]', field: '[select]', selector: 'd' },
				{
					id: '7',
					displayName: 'average_DPO',
					field: 'average_DPO',
					selector: 'e',
				},
				{
					id: '8',
					displayName: 'is_DPO_Multiple',
					field: 'is_DPO_Multiple',
					selector: 'd',
				},
				{
					id: '9',
					displayName: 'harmonization_Opportunity_Term',
					field: 'harmonization_Opportunity_Term',
					selector: 'd',
				},
			],
			groupKeys: [],
		},
		{
			cteName: 'Vendor_Working_Capital_Reduction',
			filterModel: [],
			sorting: [],
			cteTable: 'Vendor_DPO_Analysis f',
			rowGroups: [
				{
					id: '1',
					displayName: 'hARMONIZED_VENDOR_NAME',
					field: 'hARMONIZED_VENDOR_NAME',
					selector: 'f',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'f',
				},
				{
					id: '3',
					displayName: 'average_DPO',
					field: 'average_DPO',
					selector: 'f',
				},
				{
					id: '4',
					displayName: 'realized_terms',
					field: 'realized_terms',
					selector: 'f',
				},
				{ id: '5', displayName: '[select]', field: '[select]', selector: 'f' },
				{
					id: '6',
					displayName: 'extend_Term',
					field: 'extend_Term',
					selector: 'f',
				},
				{
					id: '7',
					displayName: 'pcard_Term',
					field: 'pcard_Term',
					selector: 'f',
				},
				{
					id: '8',
					displayName: 'is_DPO_Multiple',
					field: 'is_DPO_Multiple',
					selector: 'f',
				},
				{
					id: '9',
					displayName: 'harmonization_Opportunity_Term',
					field: 'harmonization_Opportunity_Term',
					selector: 'f',
				},
			],
			caseModel: [
				{
					whenCondition: 'Extend_term > realized_terms',
					thenCondition:
						'((Extend_term - realized_terms) * total_amount_paid) / 365',
					elseCondition: 'null',
					caseName: 'working_capital_reduction',
				},
				{
					whenCondition: 'pcard_term > realized_terms',
					thenCondition:
						'((pcard_term - realized_terms) * total_amount_paid) / 365',
					elseCondition: 'null',
					caseName: 'working_capital_reduction_pcard',
				},
				{
					whenCondition: 'harmonization_Opportunity_Term > realized_terms',
					thenCondition:
						'((harmonization_Opportunity_Term - realized_terms) * total_amount_paid) / 365',
					elseCondition: 'null',
					caseName: 'harmonization_Opportunity_Term_Reduction',
				},
			],
			valueCols: [],
			joinModel: [],
			havingModel: [],
			groupCols: [],
			groupKeys: [],
		},
	],
	primaryTable: 'Vendor_Working_Capital_Reduction g',
	rowGroups: [
		{
			id: '1',
			displayName: 'hARMONIZED_VENDOR_NAME',
			field: 'hARMONIZED_VENDOR_NAME',
			selector: 'g',
		},
		{
			id: '2',
			displayName: 'total_amount_paid',
			field: 'total_amount_paid',
			selector: 'g',
		},
		{
			id: '3',
			displayName: 'average_DPO',
			field: 'average_DPO',
			selector: 'g',
		},
		{
			id: '4',
			displayName: 'realized_terms',
			field: 'realized_terms',
			selector: 'g',
		},
		{ id: '5', displayName: '[select]', field: '[select]', selector: 'g' },
		{
			id: '6',
			displayName: 'extend_Term',
			field: 'extend_Term',
			selector: 'g',
		},
		{ id: '7', displayName: 'pcard_Term', field: 'pcard_Term', selector: 'g' },
		{
			id: '8',
			displayName: 'working_capital_reduction',
			field: 'working_capital_reduction',
			selector: 'g',
		},
		{
			id: '9',
			displayName: 'working_capital_reduction_pcard',
			field: 'working_capital_reduction_pcard',
			selector: 'g',
		},
		{
			id: '10',
			displayName: 'is_DPO_Multiple',
			field: 'is_DPO_Multiple',
			selector: 'g',
		},
		{
			id: '11',
			displayName: 'harmonization_Opportunity_Term',
			field: 'harmonization_Opportunity_Term',
			selector: 'g',
		},
		{
			id: '12',
			displayName: 'harmonization_Opportunity_Term_Reduction',
			field: 'harmonization_Opportunity_Term_Reduction',
			selector: 'g',
		},
	],
	filterModel: [],
	caseModel: [],
	valueCols: [],
	joinModel: [],
	havingModel: [],
	groupCols: [],
};

export const GRAPHQL_PAYLOAD_DATA_UPDATE_VENDOR = {
	columnDefs: [
		{
			headerName: 'HARMONIZED VENDOR NAME',
			field: 'hARMONIZED_VENDOR_NAME',
			colId: 'hARMONIZED_VENDOR_NAME',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			// rowGroup: true,
			// hide: true,
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'VENDOR NAME',
			field: 'vENDOR_NAME',
			colId: 'vENDOR_NAME',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			// rowGroup: true,
			// hide: true,
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Total Amount Paid',
			field: 'total_amount_paid',
			colId: 'total_amount_paid',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Average DPO',
			field: 'average_DPO',
			colId: 'average_DPO',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Realized Terms',
			field: 'realized_terms',
			colId: 'realized_terms',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Select',
			field: 'select',
			colId: 'select',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			editable: true,
			cellEditor: 'agSelectCellEditor',
			cellEditorParams: {
				values: ['YES', 'NO', 'N/A'],
			},
			headerClass: 'header-ag-black',
		},
		{
			headerName: 'Extend Term',
			field: 'extend_Term',
			colId: 'extend_Term',
			filter: 'agSetColumnFilter',

			filterParams: {
				values: [],
			},
			editable: true,
			headerClass: 'header-ag-black',
		},
		{
			headerName: 'Pcard Term',
			field: 'pcard_Term',
			colId: 'pcard_Term',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			editable: true,
			headerClass: 'header-ag-black',
		},
		{
			headerName: 'Working Capital Reduction',
			field: 'working_capital_reduction',
			colId: 'working_capital_reduction',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			headerClass: 'header-ag-blue',
		},
		{
			headerName: 'Working Capital Reduction Pcard',
			field: 'working_capital_reduction_pcard',
			colId: 'working_capital_reduction_pcard',
			filter: 'agSetColumnFilter',
			filterParams: {
				values: [],
			},
			headerClass: 'header-ag-blue',
		},
		// Add other columns here as necessary
	],
	cteExist: true,
	cteModel: [
		{
			cteName: 'Vendor_Spend_Summary',
			filterModel: [],
			sorting: [],
			cteTable: '[sxr].[working_capital] a',
			rowGroups: [
				{
					id: '1',
					displayName: 'vENDOR_NAME',
					field: 'vENDOR_NAME',
					selector: 'a',
				},
			],
			caseModel: [],
			valueCols: [
				{
					id: '1',
					aggFunc: 'sum',
					displayName: 'po_base_spend',
					field: 'po_base_spend',
					selector: 'a',
					alias: 'total_amount_paid',
				},
			],
			joinModel: [],
			havingModel: [],
			groupCols: [
				{
					id: '1',
					displayName: 'vENDOR_NAME',
					field: 'vENDOR_NAME',
					selector: 'a',
				},
			],
			groupKeys: [],
		},
		{
			cteName: 'total_Spend',
			filterModel: [],
			sorting: [],
			cteTable: 'Vendor_Spend_Summary b',
			rowGroups: [],
			caseModel: [],
			valueCols: [
				{
					id: '1',
					aggFunc: 'sum',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'b',
					alias: 'total_po_base_spend',
				},
			],
			joinModel: [],
			havingModel: [],
			groupCols: [],
			groupKeys: [],
		},
		{
			cteName: 'Vendor_Spend_Percentage',
			filterModel: [],
			sorting: [],
			cteTable: 'Vendor_Spend_Summary b , total_Spend c',
			rowGroups: [
				{
					id: '1',
					displayName: 'vENDOR_NAME',
					field: 'vENDOR_NAME',
					selector: 'b',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'b',
				},
				{
					id: '3',
					displayName:
						'total_amount_paid / c.total_po_base_spend AS spend_percentage',
					field:
						'total_amount_paid / c.total_po_base_spend AS spend_percentage',
					selector: 'b',
				},
			],
			caseModel: [],
			valueCols: [
				{
					id: '1',
					aggFunc: 'sum',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'b',
					clause: 'OVER ()',
					alias: 'total_po_base_spend',
				},
			],
			joinModel: [],
			havingModel: [],
			groupCols: [],
			groupKeys: [],
		},
		{
			cteName: 'Vendor_DPO_Analysis',
			filterModel: [{}],
			sorting: [],
			cteTable: 'sxr.working_capital d',
			rowGroups: [
				{
					id: '1',
					displayName: 'vENDOR_NAME',
					field: 'vENDOR_NAME',
					selector: 'e',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'e',
				},
				{
					id: '3',
					displayName: 'total_po_base_spend',
					field: 'total_po_base_spend',
					selector: 'e',
				},
				{ id: '4', displayName: '[select]', field: '[select]', selector: 'd' },
				{
					id: '5',
					displayName: 'pcard_Term',
					field: 'pcard_Term',
					selector: 'd',
				},
				{
					id: '6',
					displayName: 'extend_Term',
					field: 'extend_Term',
					selector: 'd',
				},
			],
			caseModel: [],
			valueCols: [
				{
					id: '1',
					aggFunc: 'avg',
					displayName: 'dPO',
					field: 'dPO',
					selector: 'd',
					alias: 'average_DPO',
				},
				{
					id: '2',
					aggFunc: 'sum',
					displayName: 'Realized_Payment_Term * e.spend_percentage',
					field: 'Realized_Payment_Term * e.spend_percentage',
					selector: 'd',
					alias: 'realized_payment_term',
				},
			],
			joinModel: [
				{
					tableName: 'Vendor_Spend_Percentage AS e',
					condition: 'd.vENDOR_NAME = e.vENDOR_NAME',
					joinType: 'RIGHT JOIN',
				},
			],
			havingModel: [],
			groupCols: [
				{
					id: '1',
					displayName: 'vENDOR_NAME',
					field: 'vENDOR_NAME',
					selector: 'e',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'e',
				},
				{
					id: '3',
					displayName: 'total_po_base_spend',
					field: 'total_po_base_spend',
					selector: 'e',
				},
				{
					id: '4',
					displayName: 'extend_Term',
					field: 'extend_Term',
					selector: 'd',
				},
				{
					id: '5',
					displayName: 'pcard_Term',
					field: 'pcard_Term',
					selector: 'd',
				},
				{ id: '6', displayName: '[select]', field: '[select]', selector: 'd' },
			],
			groupKeys: [],
		},
		{
			cteName: 'Vendor_Working_Capital_Reduction',
			filterModel: [],
			sorting: [],
			cteTable: 'Vendor_DPO_Analysis f',
			rowGroups: [
				{
					id: '1',
					displayName: 'vENDOR_NAME',
					field: 'vENDOR_NAME',
					selector: 'f',
				},
				{
					id: '2',
					displayName: 'total_amount_paid',
					field: 'total_amount_paid',
					selector: 'f',
				},
				{
					id: '3',
					displayName: 'average_DPO',
					field: 'average_DPO',
					selector: 'f',
				},
				{
					id: '4',
					displayName: 'realized_payment_term',
					field: 'realized_payment_term',
					selector: 'f',
				},
				{ id: '5', displayName: '[select]', field: '[select]', selector: 'f' },
				{
					id: '6',
					displayName: 'extend_Term',
					field: 'extend_Term',
					selector: 'f',
				},
				{
					id: '7',
					displayName: 'pcard_Term',
					field: 'pcard_Term',
					selector: 'f',
				},
			],
			caseModel: [
				{
					whenCondition: 'Extend_term > realized_payment_term',
					thenCondition:
						'((Extend_term - realized_payment_term) * total_amount_paid) / 365',
					elseCondition: 'null',
					caseName: 'working_capital_reduction',
				},
				{
					whenCondition: 'pcard_term > realized_payment_term',
					thenCondition:
						'((pcard_term - realized_payment_term) * total_amount_paid) / 365',
					elseCondition: 'null',
					caseName: 'working_capital_reduction_pcard',
				},
			],
			valueCols: [],
			joinModel: [],
			havingModel: [],
			groupCols: [],
			groupKeys: [],
		},
	],
	primaryTable: 'Vendor_Working_Capital_Reduction g',
	rowGroups: [
		{
			id: '1',
			displayName: 'vENDOR_NAME',
			field: 'vENDOR_NAME',
			selector: 'g',
		},
		{
			id: '2',
			displayName: 'total_amount_paid',
			field: 'total_amount_paid',
			selector: 'g',
		},
		{
			id: '3',
			displayName: 'average_DPO',
			field: 'average_DPO',
			selector: 'g',
		},
		{
			id: '4',
			displayName: 'realized_Payment_Term',
			field: 'realized_Payment_Term',
			selector: 'g',
		},
		{ id: '5', displayName: '[select]', field: '[select]', selector: 'g' },
		{
			id: '6',
			displayName: 'extend_Term',
			field: 'extend_Term',
			selector: 'g',
		},
		{ id: '7', displayName: 'pcard_Term', field: 'pcard_Term', selector: 'g' },
		{
			id: '8',
			displayName: 'working_capital_reduction',
			field: 'working_capital_reduction',
			selector: 'g',
		},
		{
			id: '9',
			displayName: 'working_capital_reduction_pcard',
			field: 'working_capital_reduction_pcard',
			selector: 'g',
		},
	],
	filterModel: [],
	caseModel: [],
	valueCols: [],
	joinModel: [],
	havingModel: [],
	groupCols: [],
};
